/*
 * Copyright (c) 2024. Haodong JU
 */

export const structure = {
  name: '杨国福海外/Yangguofu',
  icon: 'mdi-home-variant',
  children: [
    {
      name: '杨国福欧洲总代',
      children: [
        {
          name: 'Germany',
          children: [
            {
              name: 'NRW',
              stores: [
                {
                  name: '杨国福杜塞店',
                  addressInfo: {
                    addressLine1: 'Endstr.10',
                    addressLine2: '',
                    postCode: '12312',
                    city: 'Düsseldorf',
                    country: 'Germany'
                  },
                  status: '正常',
                  contact: '01749371328'
                }
              ]
            },
            { name: 'North Germany' },
            { name: 'Frankfurt am Main' }
          ]
        }
      ]
    },
    {
      name: '东南亚总代',
      children: []
    },
    {
      name: '北美总代',
      children: []
    },
    {
      name: '南美总代',
      children: []
    },
    {
      name: '阿拉伯语区总代',
      children: []
    },
    {
      name: '东亚总代',
      children: []
    }
  ]
}

export function nodesInTree (root) {
  const result = []
  if (root?.children?.length > 0) {
    result.push(root)
    result.push(...root.children.map(nodesInTree))
  } else {
    result.push(root)
  }
  return result.flat()
}
